import * as XLSX from "xlsx-js-style";

const exportToExcel = (data = [], fileName = "export",i18n) => {
  const formatDate = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return "";

    return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  const entradasData = data.flatMap((item) => {
    const withcrane = Boolean(item.withcrane);
    const withoutcrane = Boolean(item.withoutcrane);
    const adr = Boolean(item.adr);
    const others = Boolean(item.others);
    let hours = item.hours
      ? new Date(item.hours).toLocaleTimeString(
          i18n.language === "es" ? "es-ES" : "en-US",
          {
            hour: '2-digit',
            minute: '2-digit'
          }
        )
      : '';

    const albaranDetails = [
      item.ownshipping_id || "",
      item.number_shipping || "",
      formatDate(item.date_shipping),
      item.dest_tras_accountingentry || "",
      item.dest_tras_documentid || "",
      item.dest_tras_tradename || "",
      item.dest_tras_street || "",
      item.origin_street || "",
      item.destine_street || "",
      item.workplace || "",
      item.vehiclestore_licenseplate || "",
      item.vehiclestore_trailer || "",
      item.cranemodel_namees || "",
      item.semitrailertype_namees || "",
      item.vehiclestore_defaultdriver || "",
      item.rel_trans_documentid || "",
      item.rel_trans_tradename || "",
      item.rel_trans_street || "",
      item.opt_tras_documentid || "",
      item.opt_tras_tradename || "",
      item.opt_tras_street || "",
      item.paymenttype_code || "",
      item.paymenttype_namees || "",
      hours,
      withcrane,
      withoutcrane,
      adr,
      others,
      item.service_1 || "",
      item.weight || 0
    ];

    const lines = Array.isArray(item.linesshipping) ? [...item.linesshipping] : [];

    return lines.map((line) => {
      const amount = Number(line.amount) || 0;
      const estimatedprice = Number(line.estimatedprice) || 0;
      const discount = Number(line.discount) || 0;
      const tax = Number(line.tax) || 0;
      const taxincluded = Boolean(line.taxincluded);
      const subtotal = amount * estimatedprice;
      const discountAmount = subtotal * (discount / 100);
      const base = subtotal - discountAmount;
      const taxAmount = taxincluded ? 0 : base * (tax / 100);
      const total = base + taxAmount;

      return [
        ...albaranDetails,
        line.article_code || "",
        line.article_codeler || "",
        line.article_namees || "",
        amount,
        estimatedprice,
        subtotal,
        discount,
        discountAmount,
        tax,
        taxAmount,
        taxincluded ? "SÍ" : "NO",
        total,
      ];
    });
  });

  const headers = [
    "NÚMERO PORTE",
    "REF. CARTA DE PORTES",
    "FECHA",
    "ASIENTO CONTABLE",
    "CIF",
    "DESTINATARIO/CLIENTE/CARGADOR",
    "DOMICILIO",
    "LUGAR DE ORIGEN",
    "LUGAR DE DESTINO",
    "OBRA",
    "CAMIÓN",
    "REMOLQUE",
    "MODELO GRÚA",
    "TIPO REMOLQUE",
    "CONDUCTOR",
    "CIF",
    "TRANSPORTISTA",
    "DOMICILIO",
    "CIF",
    "EMPRESA OPERADORA",
    "ORIGEN CARGA",
    "CÓDIGO FORMA DE PAGO",
    "FORMA DE PAGO",
    "TRABAJO EFECTUADO POR",
    "CON GRÚA",
    "SIN GRÚA",
    "ADR",
    "OTROS",
    "SERVICIO",
    "PESO",
    "CÓDIGO ARTÍCULO",
    "CÓDIGO L.E.R ASOCIADO",
    "DESCRIPCIÓN ARTÍCULO",
    "CANTIDAD",
    "PRECIO ESTIMADO",
    "TOTAL",
    "DESCUENTO",
    "TOTAL DESCUENTO",
    "I.G.I.C",
    "TOTAL IMPUESTO",
    "INCLUIDO",
    "TOTAL",
  ];

  const entradasWorksheet = XLSX.utils.aoa_to_sheet([headers, ...entradasData]);

  const range = XLSX.utils.decode_range(entradasWorksheet["!ref"]);

  const headerStyle = {
    font: {
      bold: true,
      color: { rgb: "FFFFFF" },
      sz: 11,
    },
    fill: {
      fgColor: { rgb: "1F4E78" },
    },
    alignment: {
      horizontal: "center",
      vertical: "center",
      wrapText: true,
    },
    border: {
      top: { style: "thin", color: { rgb: "D9E2F3" } },
      bottom: { style: "thin", color: { rgb: "D9E2F3" } },
      left: { style: "thin", color: { rgb: "D9E2F3" } },
      right: { style: "thin", color: { rgb: "D9E2F3" } },
    },
  };

  const bodyStyle = {
    alignment: {
      vertical: "center",
      horizontal: "left",
    },
    border: {
      top: { style: "thin", color: { rgb: "EAEAEA" } },
      bottom: { style: "thin", color: { rgb: "EAEAEA" } },
      left: { style: "thin", color: { rgb: "EAEAEA" } },
      right: { style: "thin", color: { rgb: "EAEAEA" } },
    },
  };

  const numberStyle = {
    ...bodyStyle,
    alignment: {
      vertical: "center",
      horizontal: "right",
    },
    numFmt: "0.00",
  };

  const dateStyle = {
    ...bodyStyle,
    alignment: {
      vertical: "center",
      horizontal: "center",
    },
  };

  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    if (entradasWorksheet[cellAddress]) {
      entradasWorksheet[cellAddress].s = headerStyle;
    }
  }

  const decimalColumns = [29,33,34,35,36,37,38,39,41];
  const dateColumns = [2];

  for (let row = 1; row <= range.e.r; row++) {
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      const cell = entradasWorksheet[cellAddress];

      if (!cell) continue;

      if (decimalColumns.includes(col)) {
        if (cell.v !== "" && cell.v !== null && cell.v !== undefined) {
          cell.t = "n";
          cell.v = Number(cell.v) || 0;
          cell.s = numberStyle;
        }
      } else if (dateColumns.includes(col)) {
        cell.s = dateStyle;
      } else {
        cell.s = bodyStyle;
      }
    }
  }

  entradasWorksheet["!cols"] = [
    { wch: 14 },//"NÚMERO PORTE",
    { wch: 18 },//"REF. CARTA DE PORTES",
    { wch: 12 },//"FECHA",
    { wch: 18 },//"ASIENTO CONTABLE",
    { wch: 14 },//"CIF",
    { wch: 24 },//"DESTINATARIO/CLIENTE",
    { wch: 24 },//"DOMICILIO",
    { wch: 24 },//"LUGAR DE ORIGEN",
    { wch: 24 },//"LUGAR DE DESTINO",
    { wch: 24 },//"OBRA",
    { wch: 12 },//"CAMIÓN",
    { wch: 12 },//"REMOLQUE",
    { wch: 12 },//"MODELO GRÚA",
    { wch: 12 },// "TIPO REMOLQUE",
    { wch: 18 },//"CONDUCTOR",
    { wch: 14 },// "CIF",
    { wch: 24 },//"TRANSPORTISTA",
    { wch: 24 },//"DOMICILIO",
    { wch: 14 },// "CIF",
    { wch: 24 },//"EMPRESA CARGADORA",
    { wch: 24 },//"ORIGEN CARGA",
    { wch: 18 },// "CÓDIGO FORMA DE PAGO",
    { wch: 18 },//"FORMA DE PAGO",
    { wch: 18 },//"TRABAJO EFECTUADO POR",
    { wch: 18 },// "CON GRÚA",
    { wch: 18 },// "SIN GRÚA",
    { wch: 18 },//"ADR",
    { wch: 18 },//"OTROS",
    { wch: 24 },//"SERVICIO",
    { wch: 18 },//"PESO",
    { wch: 16 },//"CÓDIGO PROPIO",
    { wch: 16 },// "CÓDIGO L.E.R ASOCIADO",
    { wch: 20 },//"DESCRIPCIÓN ARTÍCULO", 
    { wch: 12 },////"CANTIDAD",
    { wch: 16 },// "PRECIO ESTIMADO",
    { wch: 16 },// "TOTAL",
    { wch: 16 },//"DESCUENTO",
    { wch: 16 },//"TOTAL DESCUENTO",
    { wch: 16 },//"I.G.I.C",
    { wch: 16 },//"TOTAL IMPUESTO",
    { wch: 10 },//"INCLUIDO",
    { wch: 16 },//"TOTAL",
  ];

  entradasWorksheet["!autofilter"] = {
    ref: XLSX.utils.encode_range(range),
  };

  entradasWorksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

  const workbook = XLSX.utils.book_new();
  const safeFileName = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;

  XLSX.utils.book_append_sheet(workbook, entradasWorksheet, "CARTAS DE PORTES");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true,
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = safeFileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export default exportToExcel;